import React, { useState, useRef, useEffect } from 'react';

interface TimePickerProps {
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
}

export const TimePicker: React.FC<TimePickerProps> = ({ value, onChange, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const [h, m] = value.split(':');

  const hours = [];
  for (let i = 8; i <= 20; i++) hours.push(i.toString().padStart(2, '0'));
  
  const minutes = [];
  for (let i = 0; i < 60; i += 5) minutes.push(i.toString().padStart(2, '0'));

  const handleHourClick = (val: string) => {
    onChange(`${val}:${m}`);
  };

  const handleMinuteClick = (val: string) => {
    onChange(`${h}:${val}`);
  };

  return (
    <div className={`time-picker ${isOpen ? 'open' : ''}`} ref={ref}>
      <button 
        type="button" 
        className="time-picker-btn" 
        disabled={disabled}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="time-picker-value">{value}</span><span>⌄</span>
      </button>
      <div className="time-picker-popover">
        <div className="time-list hours">
          {hours.map(hr => (
            <button 
              key={hr} 
              type="button" 
              className={`time-option ${hr === h ? 'selected' : ''}`}
              onClick={() => handleHourClick(hr)}
            >
              {hr}
            </button>
          ))}
        </div>
        <div className="time-list minutes">
          {minutes.map(mn => (
            <button 
              key={mn} 
              type="button" 
              className={`time-option ${mn === m ? 'selected' : ''}`}
              onClick={() => handleMinuteClick(mn)}
            >
              {mn}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
